import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  HostListener,
  AfterViewInit,
  OnDestroy,
  Inject,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";

import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";

import { MatSidenav } from "@angular/material/sidenav";
import { NgxMatDateFormats, NGX_MAT_DATE_FORMATS } from "@angular-material-components/datetime-picker";
import { MatDateFormats, MAT_DATE_FORMATS } from "@angular/material/core";

import { Observable, Subscription } from "rxjs";
import { Store, select } from "@ngrx/store";
import { logOut } from "./store/actions/login/login.actions";
import {
  AppState,
  loadedMenusState,
  loginStateisAuthenticated,
  loginStateShowExpired,
  messagesStateGetMessage,
  messagesStateGetMessageResetFlag,
  messagesStateClearMessages,
  messagesStateGetSnackbar,
  loadedTenantConfigState,
  isLoadingMenusState,
} from "./store/reducers";
import { getMenus } from "./store/actions/menus/menu.actions";

import { routes } from "./app-routing.module";

import { AppMessage } from "./models/common/appMessage";
import { MenuDTO } from "./models/Menu/MenuDTO";
import { getCurrentTenantFormatList } from "./store/actions/tenant/tenant.actions";
import { SnackbarService } from "./shared/services/snackbar/snackbar.service";
import { SnackbarData } from "./models/snackbar/snackbar.model";
import { MatDialog } from "@angular/material/dialog";
import { PasswordDialogComponent } from "./shared/modules/dialogs/password-dialog/password-dialog.component";
import { AboutDialogComponent } from "./shared/modules/dialogs/about-dialog/about-dialog.component";
import { Dialog } from "./models/dialog/dialog.model";

import { validateColorHexadecimal } from "../app/shared/utils/colorUtils";
import { DashboardThemeService } from "./shared/services/dashboard-theme/dashboard-theme.service";
import { UserProfileCodes } from "./models/UserDetails/userProfileDTO";

import { environment } from "src/environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("sidenav") sidenavList: QueryList<MatSidenav>;
  sidenav: MatSidenav;

  public smallScreen: boolean = undefined;

  public appVersion = environment?.appVersion;

  public innerWidth: any;
  public darkTheme = false;
  public snackbar$: Observable<SnackbarData>;
  public message$: Observable<AppMessage>;
  public messageServiceReset$: Observable<boolean>;
  public snackbarSubs: Subscription;
  public messageSubs: Subscription;
  public messageServiceResetSubs: Subscription;
  messageServiceClearSubs: Subscription;
  messageServiceClear$: Observable<string>;

  // Authenticate
  isAuth$: Observable<boolean>;
  showExpired$: Observable<boolean>;

  //Tenant
  tenantConfigSub: Subscription;
  tenantConfig$: Observable<any>;

  selectedTenantToken: string;

  // Locale
  public locale: string = localStorage.getItem("locale");

  public showMenus: boolean;

  menuIsLoading$: Observable<boolean>;
  menusList$: Observable<MenuDTO[]>;
  menusList: MenuDTO[];
  menusListToShow: MenuDTO[];

  user: string;

  userName = "";

  userProfileCodes = UserProfileCodes;

  public topNavLinks: Array<{
    path: string;
    name: string;
    iconName: string;
    iconFontSet: string;
    parent?: boolean;
    children?: any[];
    code?: string;
  }> = [];
  themes = [];

  index = 0;

  selected: any;
  navigate: any;
  showMessages: boolean;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.configureSideNav();
  }

  private _listener = (storageEvent: StorageEvent) => {
    const { key } = storageEvent;
    if (!key && !localStorage.getItem("isAuthenticated")) {
      this.logout();
    }
  };

  constructor(
    private translate: TranslateService,
    private router: Router,
    private store: Store<AppState>,
    private snackbarService: SnackbarService,
    public dialog: MatDialog,
    private dashboardTheme: DashboardThemeService,
    @Inject(NGX_MAT_DATE_FORMATS) private dateTimeFormats: NgxMatDateFormats,
    @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats
  ) {
    this.menusList = [];
    this.menusList$ = this.store.pipe(select(loadedMenusState));
    this.menuIsLoading$ = this.store.pipe(select(isLoadingMenusState));
    this.isAuth$ = this.store.pipe(select(loginStateisAuthenticated));
    this.message$ = this.store.pipe(select(messagesStateGetMessage));
    this.snackbar$ = this.store.pipe(select(messagesStateGetSnackbar));
    this.messageServiceReset$ = this.store.pipe(
      select(messagesStateGetMessageResetFlag)
    );
    this.messageServiceClear$ = this.store.pipe(
      select(messagesStateClearMessages)
    );
    this.tenantConfig$ = this.store.pipe(select(loadedTenantConfigState));
    this.showExpired$ = this.store.pipe(select(loginStateShowExpired));

    if (this.isAuth$ !== undefined && this.isAuth$ !== null) {
      this.isAuth$.subscribe((isAuth) => {});
    }
  }

  public ngOnInit(): void {
    this.menusList = [];
    this.userName = localStorage.getItem("loggedUser");
    this.setTenantSubscription();

    if (this.isAuthenticated()) {
      this.store.dispatch(getMenus());
      this.store.dispatch(getCurrentTenantFormatList(null));
    }

    this.menusList$.subscribe((menu) => {
      this.menusList = [];
      this.topNavLinks = [];

      if (menu !== undefined && menu !== null) {
        this.menusList = menu;
        this.menusListToShow = _.cloneDeep(this.menusList);
        this.menusList.forEach((menuEl) => {
          this.subMenusIterator(menuEl);
        });
      }
    });

    this.snackbarSubs = this.snackbar$.subscribe((snackbar) => {
      if (snackbar) {
        this.snackbarService.show({
          message: snackbar.message,
          type: snackbar.type,
        });
      }
    });

    this.messageServiceResetSubs = this.messageServiceReset$.subscribe(
      (messageResetFlag) => {
        if (messageResetFlag === true) {
          this.showMessages = false;
        } else {
          this.showMessages = true;
        }
      }
    );

    this.themes = [
      { id: "essos", value: "a46eb8", selected: true },
      { id: "macarons", value: "FCB3C4" },
      { id: "dark", value: "a2a3a4" },
    ];
  }
  
  ngAfterViewInit() {
    this.userName = localStorage.getItem("loggedUser");
    if (this.userName?.length > 0 && this.userName !== null) {
      this.store.dispatch(getMenus());
      this.store.dispatch(getCurrentTenantFormatList(null));
    }

    this.sidenavList.changes.subscribe((comps: QueryList<MatSidenav>) => {
      this.sidenav = comps.first;
      setTimeout(() => {
        this.configureSideNav();
      }, 0);
    });

    if (window.addEventListener) {
      window.addEventListener("storage", this._listener, false);
    }
  }

  setTenantSubscription(): void {
    this.tenantConfigSub = this.tenantConfig$.subscribe((data: any) => {
      if (data) {
        const { token, tenantDataFormat } = data;
        this.selectedTenantToken = token;
        this.dateTimeFormats.display.dateInput = tenantDataFormat.datetimeFormat;
        this.dateFormats.display.dateInput = tenantDataFormat.dateFormat;

        if (
          tenantDataFormat.primaryColor &&
          validateColorHexadecimal(tenantDataFormat.primaryColor)
        ) {
          document.documentElement.style.setProperty(
            "--primary",
            `#${tenantDataFormat.primaryColor}`
          );
        }
        if (
          tenantDataFormat.secondaryColor &&
          validateColorHexadecimal(tenantDataFormat.secondaryColor)
        ) {
          document.documentElement.style.setProperty(
            "--secondary",
            `#${tenantDataFormat.secondaryColor}`
          );
        }
      }
    });
  }

  subMenusIterator(menuElement: MenuDTO) {
    const { code, subMenus } = menuElement;
    if (code && code === "folder") {
      for (const subMenuEl of subMenus) {
        this.subMenusIterator(subMenuEl);
      }
    } else {
      this.checkRoutesArray(menuElement);
    }
  }

  checkRoutesArray(menuElement: MenuDTO) {
    const route = routes.find(
      (route) => route?.data?.code === menuElement.code
    );
    if (route) {
      const newMenuElObj = {
        ...menuElement,
        path: `/${route.path}`,
      };
      this.setRoutesPath(this.menusListToShow, newMenuElObj);
    }
  }

  setRoutesPath(menuArray: MenuDTO[], newMenuElObj: MenuDTO) {
    menuArray.forEach((item, index, array) => {
      if (item.code === newMenuElObj.code) {
        array[index] = { ...newMenuElObj };
      } else {
        if (item.subMenus) {
          this.setRoutesPath(item.subMenus, newMenuElObj);
        }
      }
    });
  }

  isAuthenticated(): boolean {
    if (this.router.url === "/login" || this.router.url === "/" || this.router.url.includes("/passwordRecovery")) {
      return false;
    } else {
      if (localStorage) {
        return localStorage.getItem("isAuthenticated") &&
          localStorage.getItem("isAuthenticated") === "true"
          ? true
          : false;
      }
    }

    return false;
  }

  public logout() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.store.dispatch(logOut());
  }

  public login() {
    this.router.navigate(["/login"]);
    localStorage.getItem("isAuthenticated");
  }

  getUserFromStorage(): string {
    return localStorage.getItem("loggedUser") || "";
  }

  getUserProfileFromStorage() {
    return localStorage.getItem("profileCode") || "";
  }

  configureSideNav() {
    if (!this.sidenav) {
      return;
    }

    this.innerWidth = window.innerWidth;
    var calcSmallScreen = window.innerWidth < 901 ? true : false;

    if (this.smallScreen === calcSmallScreen) return;

    this.smallScreen = calcSmallScreen;
    if (!this.smallScreen) {
      this.sidenav.mode = "side";
      this.sidenav.opened = true;
    } else {
      this.sidenav.mode = "over";
      this.sidenav.opened = false;
    }
  }

  openChangePassword() {
    const dialogData: Dialog = this.setConfirmationDialogData();
    this.dialog.open(PasswordDialogComponent, dialogData);
  }

  setConfirmationDialogData(): Dialog {
    return {
      data: {
        message: "TableTemplate.ConfirmationDialog.Message",
        buttonText: {
          ok: "TableTemplate.PasswordDialog.AcceptButton",
          cancel: "TableTemplate.PasswordDialog.CancelButton",
        },
      },
    };
  }

  openAbout() {
    this.dialog.open(AboutDialogComponent, {
      width: '400px'
    });
  }

  changeTheme(theme: any) {
    this.dashboardTheme.changeTheme(theme.id);
    this.themes.forEach((t) => (t.selected = false));
    let selectedTheme = this.themes.find((t) => t.id === theme.id);
    selectedTheme.selected = true;
  }

  ngOnDestroy() {
    if (this.messageSubs) {
      this.messageSubs.unsubscribe();
    }
    if (this.messageServiceResetSubs) {
      this.messageServiceResetSubs.unsubscribe();
    }
    if (this.messageServiceClearSubs) {
      this.messageServiceClearSubs.unsubscribe();
    }
    if (this.tenantConfigSub) {
      this.tenantConfigSub.unsubscribe();
    }
    window.removeEventListener("storage", this._listener, false);
  }
}
